import logo from '../assets/logo.png';
import pitch from '../assets/pitch.svg';
import bg from '../assets/bg.png';
import ball from '../assets/ball.svg';
import home_hero from '../assets/home_hero.png';
import osu from '../assets/osu.png';
import field_map from '../assets/field_map.png';
import venmo from '../assets/venmo.png';
import CRHanna from '../assets/CRHanna.png';
import lovePark from '../assets/lovePark.png';
import crParking from '../assets/crParking.png';



export default {
    logo,
    pitch,
    bg,
    ball,
    home_hero,
    osu,
    venmo,
    field_map,
    CRHanna,
    lovePark,
    crParking
    
}